import replace from 'lodash/replace'

export default (image, quality = 'medium') => {
    return replace(image, 'original', quality);
}